


























































































import { Component, Vue } from "vue-property-decorator";
import vueSeamlessScroll from "vue-seamless-scroll";
import { getRankTop } from "@/req/homes";
@Component({
  components: { vueSeamlessScroll },
})
export default class Home extends Vue {
  public listDataOne = [
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/yschuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/cylc.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/nhyd.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/feiyangchuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/yangguangchuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/lantian.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/wanmeichuanqi.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/haomeng.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/huihuangchuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/menghuifg.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/shengxinchuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/wangchen.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/longchengwl.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/quanmingpysk.png",
    },
  ];
  public listDataTwo = [
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/mojiaochuanqi.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/rongteng.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/rehuochuanqiLOGO.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/rongyaochuanqi.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/yuxuechuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/tianyi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/huaijiufuguchuanqi.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/yangguangs.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/qinghuai.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/jinzu.png",
    },
    // {
    //   src:
    //     "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/mafa.jpg",
    // },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/qinwa.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/qinfeng.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/rxdjbx.png",
    },
  ];
  public listDataThree = [
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/tiandao.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/tiexue.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/wujiu.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/xianfeng.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/chonghui.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/bite.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/baiju.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/cuican.jpg",
    },
    // {
    //   src:
    //     "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/huainiancq.png",
    // },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/leyou.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/ruyi.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/longyang.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/ditian.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/xunlong.png",
    },
  ];
  public listDataFour = [
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/qihuang.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/shengjing.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/longzhi.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/zhuoyue.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/shenhua.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/cangyue.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/kaizhan.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/wangzi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/kkkchuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/senlinwangluo.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/shiguangfugu.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/zhuluchuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/xirichuanqi.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/aoshiliehuo.png",
    },
  ];
  public listDataFive = [
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/qiyuanchuanqi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/hongmeng.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/sanyisanqisan.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/shuanglong.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/xianyue.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/chuxin.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/wanwan.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/zhantian.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/qingyi.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/mujian.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/leinuo.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/feihong.png",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/zhanren.jpg",
    },
    {
      src: "https://static.dhsf.xqhuyu.com/offical/static/img/according_logo/qiyuan.png",
    },
  ];
  public optionData = {
    step: 1, // 数值越大速度滚动越快
    limitMoveNum: 20, // 开始无缝滚动的数据量 this.dataList.length
    hoverStop: true, // 是否开启鼠标悬停stop
    direction: 3, // 0向下 1向上 2向左 3向右
    openWatch: true, // 开启数据实时监控刷新dom
    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
    waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
  };
  public created() {
    this.getList();
  }
  public async getList() {
    const res = await getRankTop({});
    if (res.code == 200) {
      this.listDataOne = res.data.slice(0, 20);
      this.listDataTwo = res.data.slice(20, 40);
      this.listDataThree = res.data.slice(40, 60);
      this.listDataFour = res.data.slice(60, 80);
      this.listDataFive = res.data.splice(80, 100);
    } else {
      this.$Message.error(res.msg);
    }
  }
  public toDetail(e) {
    const data = JSON.parse(e.target.dataset.obj);
  }
  public bannerMouseover() {
    this.optionData.step = 0;
  }
  public bannerMouseleave() {
    this.optionData.step = 1;
  }
}
